import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import PriceRuleDetailsForm from "../../../components/forms/setup/priceRules/PriceRuleDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function PriceRulesViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [priceRules, setPriceRules] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getPriceRules = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`priceRules`, payload);
    setLoading(false);
    if (callResult.success) {
      setPriceRules(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createPriceRule = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createPriceRule", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Price rule added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getPriceRules("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updatePriceRule = async function (priceRule, values, index) {
    let callResult = await makePostApiCall(`updatePriceRule`, {
      id: priceRule.id,
      name: values.name,
      description: values.description ?? null,
    });

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Price rule updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getPriceRules("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddPriceRuleSlideOver = () => {
    setSlideOver({
      childComponent: (
        <PriceRuleDetailsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createPriceRule}
        />
      ),
      open: true,
    });
  };

  const viewPriceRuleDetails = async function (priceRule, index) {
    setSlideOver({
      childComponent: (
        <PriceRuleDetailsForm
          priceRule={priceRule}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updatePriceRule}
        />
      ),
      open: true,
    });
  };

  const deletePriceRule = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deletePriceRule/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getPriceRules(null, 0);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeletePriceRule = function (priceRule, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deletePriceRule(priceRule.id, index)}
          message={`Are you sure you want to delete ${priceRule.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeletePriceRule,
    emptyModal,
    setEmptyModelOpen,
    createPriceRule,
    getPriceRules,
    loading,
    priceRules,
    openAddPriceRuleSlideOver,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    updatePriceRule,
    viewPriceRuleDetails,
  };
}
